import React from 'react';

export const RefreshSvg = () => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
        <path
            fill="currentColor"
            d="M5 12a7 7 0 0 1 7-7c.911 0 1.642.113 2.356.42.722.309 1.494.844 2.437 1.787l.672.672c.481.481 1.127.963 1.77 1.389v.203a1 1 0 0 1-.183-.029C18.115 9.212 17.002 9 16.1 9h-.762a1 1 0 0 0 .004 2H21a1 1 0 0 0 1-1V4.334a1 1 0 0 0-2 .01v.778c.003.897.215 2 .442 2.93q.023.091.029.182h-.203c-.426-.642-.908-1.288-1.39-1.77l-.67-.671C17.15 4.736 16.171 4.02 15.143 3.58 14.108 3.137 13.089 3 12 3a9 9 0 1 0 6.349 15.38 1 1 0 1 0-1.411-1.418A7 7 0 0 1 5 12"
        />
    </svg>
);
